import React from 'react';
import { Button } from '@veeqo/ui';

export const NavigateButton = ({ href, text }: { href: string; text: string }) => (
  <Button
    onClick={() => {
      const a = document.createElement('a');
      a.href = href;
      a.rel = 'noopener noreferrer';
      a.target = '_blank';
      a.click();
    }}
    variant="default"
  >
    {text}
  </Button>
);
